import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "pro-payment-method-refused" as const;

export type ProPaymentMethodRefusedEventData = {
  proPaymentMethodId: string;
};

export type ProPaymentMethodRefusedEvent = AppEvent<
  typeof eventName,
  ProPaymentMethodRefusedEventData
>;

export const isProPaymentMethodRefusedEvent = (
  event: AnyAppEvent
): event is ProPaymentMethodRefusedEvent => event.name === eventName;

export { eventName as proPaymentMethodRefused };
